<div class="container-admin">
  <form [formGroup]="resetPassForm" class="main-content">
    <div class="form tpl-form-2">
      <div class="container-img">
        <img src="assets/image/logo-admin.svg" />
      </div>
      <h2>Plataforma OZ</h2>
      <h4 class="oz-login-subtitle">Admin</h4>

      <hr />

      <div class="content-login-admin">
        <h4 class="form-login-title">Esqueceu a senha</h4>
        <div class="form-login-subtitle">
          Enviaremos um link para a criação de uma nova senha.
        </div>

        <div class="form-row">
          <div class="col-xl-12">
            <mat-form-field appearance="outline">
              <mat-label>E-mail profissional</mat-label>
              <input matInput formControlName="email" type="text" />
              <mat-error
                class="mb-1"
                *ngIf="
                  resetPassFormControl.email.touched &&
                  resetPassFormControl.email.errors?.required
                "
              >
                E-mail obrigatório
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-group mb-0">
          <button
            [ngClass]="{
              'btn-gray-disabled': resetPassForm.invalid,
              'btn-dark-blue': !resetPassForm.invalid
            }"
            [disabled]="resetPassForm.invalid"
            class="btn btn-block mb-3"
            type="button"
            (click)="sendResetEmail()"
          >
            Entrar
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </div>

        <div (click)="goBack()" class="text-login">
          <p>Voltar ao login</p>
        </div>
      </div>
    </div>
  </form>
</div>
